module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('p', {
    staticClass: "cn-only",
    attrs: {
      "id": "ch2"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/contents#c_ch2"
    }
  }, [_vm._v("TWO")])]), _vm._v(" "), _c('p', {
    staticClass: "tni"
  }, [_vm._v("Looping the strap of her shoulder bag over the back of a tall stool, Viola sat down, watching the measured actions of Tyrell as he washed his hands in a stainless-steel sink before drying them and looping a bibbed apron over his head.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("Waiting until he tied the apron around his slim waist, she said, “This is the cooperative’s third year. The mission is to link up students with business establishments in the D.C. area. After an orientation, they will work one day each week in lieu of attending classes.”")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("Tyrell pulled on a pair of large black rubber gloves. “How do you determine which students are eligible?”")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("“A vocational survey is administered to all incoming freshmen, and based upon the results of a computer analysis, we can usually determine a student’s career focus. We then extrapolate those with an interest in the business sector.”")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("“Do all of the grades participate?”")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("Viola shook her head. “No. The initiative is geared mainly to seniors. There was an exception this year because the committee selected a junior.” Viola wanted to tell Tyrell that this student had expressed an interest in restaurant management. “The participants are paid a stipend, usually above minimum wage.”")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("Tyrell glanced at Viola, admiring the long leg she had looped over the opposite knee. How, he wondered, were high school boys able to concentrate on their studies when their teacher looked like a high-fashion model?")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("“Are they permitted to work beyond the one day per week?”")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("“Yes. But not more than twenty hours each week.”")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("Reluctantly he pulled his gaze away, reached into the tank, and caught a large thrashing crustacean. He placed it on a scale, peering closely at the numbers before returning it to the tank. He selected another lobster and weighed it.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("“How much does that monster weigh?” The lobster on the industrial-size scale was huge.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("“Sh-hh,” Tyrell whispered. “Don’t let Brutus hear you.” She laughed softly, unaware of how the low, subdued, and sensual sound affected him. “I’ve been saving him for a special occasion.”")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("Viola lifted an eyebrow. “Is this a special occasion?”")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("“I’d like to think so, Viola.” He gave her a long, penetrating stare. “You’ve come to Leo’s because you want something, and I’m thinking of accepting your proposal because I, too, want something.” He didn’t say was that something was a desire to know more about Viola Chapman.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("She felt her pulse quicken. She hadn’t thought it would be that easy for Tyrell to accept the initiative. Leo’s would be a perfect venue, except that she wanted to place students at the restaurant who were interested in management, not cooking.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("“None of the students have expressed an interest in becoming chefs.”")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("“Have you asked them?”")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("A wave of heat rushed to her face. “No.”")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("“I suggest you do. Chefs have come a long way since Julia Child came into our homes on public television more than thirty years ago. We now have our own cable channel, the Food Network.”")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("Viola nodded in agreement. Cooking segments and celebrity chefs had become a part of the American landscape. Most morning shows highlighted regional dishes and restaurants. Devoting an entire channel to cooking had verified the country’s passionate obsession with food.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("“Tyrell?”")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("He smiled at her. “Yes, Viola.”")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("“I’d like to ask a favor of you.”")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("“Ask.”")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("“Please don’t cook Brutus.”")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("He stared at her for several seconds before throwing back his head, roaring with laughter. The rich sound came deep from within his chest. Viola sat up straighter, pretending indifference. She didn’t know what was so funny. All she’d asked was that he not cook the lobster.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("Tyrell picked up Brutus, smiling. “You’ve been spared, old man, because of a woman who’s not only soft-hearted, but also quite beautiful.” Taking several steps, he returned the spared lobster to the tank.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("Sighing in relief, she smiled. “Can’t you prepare something that you don’t have to kill?”")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("“But you said you wanted fresh fish.”")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("“I do.”")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("“I have shrimp and catfish already cleaned and filleted.”")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("“Okay.” There was a tremor of relief in her voice.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("Opening a walk-in refrigerator-freezer, Tyrell picked up two labeled plastic containers. Viola’s not wanting him to kill the lobster revealed a lot about her. She was compassionate. He had dated some women who were so competitive and aggressive that it usually diminished their femininity. In their goal to make it or become the best, they’d forgotten they were women first.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("It wasn’t that he did not admire a woman who wanted a successful career, but not at the risk of forfeiting what made her female. Everything about Viola Chapman indicated success, down to her choice in attire and accessories, yet her success had not overshadowed that she was wholly "), _c('span', {
    staticClass: "epub-i"
  }, [_vm._v("woman.")])]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("He placed containers on a countertop. “Do you eat pork products, or are you allergic to peanuts?”")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("Uncrossing her legs, Viola slid off the stool and closed the distance between them. Three inches of heels put her at five-ten, yet he still eclipsed her height by another five or six inches.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("“Yes and no.” She moved closer. “What are you going to make?”")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("“Sesame-crusted catfish with a Geechee peanut sauce.”")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("“My grandfather was a Geechee. I never understood half of what he said.”")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("“Where was he from?” Tyrell asked.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("“Edisto Island. He taught me a proverb that says: ‘"), _c('span', {
    staticClass: "epub-i"
  }, [_vm._v("If oonuh ent kno weh oonuh dah gwine, oonuh should kno weh oonuh come f")]), _vm._v("’"), _c('span', {
    staticClass: "epub-i"
  }, [_vm._v("um.")]), _vm._v("’”")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("“‘If you don’t know where you’re going, you should know where you come from.’”")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("Her eyes glittered with excitement. “You understand the language.”")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("“There happen to be a few Geechees in the Hardcastle family tree.”")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("Tyrell admired her enchanting profile. Her gray-streaked black shiny hair was the perfect style for her face. His gaze lingered on the straighter strands lying in perfect precision on her long neck. He’d tried guessing her age and failed. Despite the salt-and-pepper hair, her face claimed no lines or wrinkles. He was thirty-three, and he estimated that if she was older than that, it could only be by a few years.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("“Would you like some help?” she asked, her dark gaze meeting his golden one.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("He drank in her stunning beauty. “Do you cook?”")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("“Not much.”")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("“How much is not much?”")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("“I can broil a steak, bake potatoes, and boil rice in a bag.”")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("“What about vegetables?”")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("“There’s always bagged salad and frozen vegetables.”")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("He stared, complete surprise on his face. “No wonder you’re so skinny.”")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("Her jaw dropped. “I’m not skinny.”")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("“Thin, skinny. It’s all the same,” he countered, waving a hand.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("Folding her hands on her slim hips, Viola thrust her face close to Tyrell’s. “You’re a fine one to talk.”")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("He gave her a placating smile. “I’m willing to bet that I’m closer to one-ninety than you are to one-twenty.”")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("Viola wanted to tell him she weighed one hundred twenty-five pounds. But her vital statistics were none of his business. She had come to Leo’s to present Carver’s career initiative, not argue about whether she was too thin for Tyrell Hardcastle’s personal tastes.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("“If I can’t help, then maybe I can watch you and "), _c('span', {
    staticClass: "epub-i"
  }, [_vm._v("learn")]), _vm._v(" something,” she retorted, all business again.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("His eyes narrowed slightly. “You’ve got a sharp tongue, Viola.”")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("“It comes with the profession, Tyrell. After all, I teach high school.”")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("“What subject?”")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("“English.”")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("He grimaced. “My worst subject.”")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("“Did you excel in any?”")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("“In fact, I excelled in all of them except English. It was the only course where I couldn’t pull an A.”")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("“What did you get?”")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("He paused, and then said, “B.”")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("“Touché,” she whispered softly.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("Nodding, Tyrell leaned down and kissed her cheek. The scent of her perfume lingered in his nostrils after he’d raised his head. Reaching for her hand, he held it gently within his warm grasp. “You can help me by setting one of the tables.”")]), _vm._v(" "), _c('p', {
    staticClass: "orn"
  }, [_vm._v("*   *   *")]), _vm._v(" "), _c('p', {
    staticClass: "sb"
  }, [_vm._v("Viola set a table for two with china, silver, and crystal in a corner of the dining room near a wall of stained glass. The shifting late-afternoon autumn sun streaming through the glass sparkled like diamonds, emeralds, rubies, sapphires, and citrines.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("Tyrell had turned on a sound system from which flowed the soft sounds of contemporary jazz. Within minutes all of the accolades she’d heard about Leo’s were manifested. A massive rosewood bar with a gleaming brass railing reflected overhead recessed lights.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("Her fingers traced the luxurious fabric on the backs of padded stools lining the bar. It was apparent the Hardcastles had spared no expense when it came to decorating their upscale supper club.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("Tyrell walked into the dining room, smiling. An overhead light created a halo around his head and face, turning him into a statue of molten gold.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("“What’s your wine preference?”")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("“White.”")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("He winked at Viola. “I’ll be right back.”")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("She watched Tyrell as he made his way to a door at the opposite end of the dining room, admiring his loose-limbed walk. Five minutes later he reappeared, cradling a bottle of wine in the crook of one arm.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("“Like Brutus, I’ve been waiting a long time to open this.”")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("“What year is the vintage?”")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("“1974.”")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("She lifted her eyebrows. “That’s thirty years old.”")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("He stared at the label. “But it’s not really old. There are people who have private collections that are more than sixty years old. I read about someone in Europe who bought a 1938 Lafite Mouton Rothschild at auction for an astronomical price.”")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("Viola smiled. “My mother was born in 1938.”")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("Picking up a corkscrew, Tyrell opened the bottle, permitting the wine to breathe. He poured a small amount into a glass, handing it to Viola before he repeated the action for himself. Touching glasses, they sampled the vintage wine.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("Nodding and smiling, she said, “It’s wonderful.”")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("“You get what you pay for,” Tyrell confirmed.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("“What did you pay for this bottle?”")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("He winked at her. “I’m not telling. I found it at a vineyard in the Loire Valley several years ago.”")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("Resting her elbows on the bar’s gleaming surface, Viola stared directly at the man who had more than aroused her curiosity. He was much more complex than she’d originally thought.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("“Do you speak French?”")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("“French, a little German, Spanish, and Italian. My brothers and I were army brats. By the time we were eighteen, we’d lived on army bases on three continents.”")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("“How did your mother adjust to being a military wife?”")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("“She never bonded with the other officers’ wives because she was a teacher.”")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("“What did she teach?”")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("“High school math. Even after Leo retired and returned to the States, Mom continued to teach. She finally retired last year.”")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("Viola raised her wineglass. “Here’s to a noble and rewarding profession.”")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("Tyrell leaned closer. “Has it been rewarding?”")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("“For me it has been.”")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("“How long have you been a teacher?”")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("“Nineteen years.”")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("Tyrell’s Adam’s apple moved up and down in his throat as he tried to form the words to speak. “How … how long?”")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("“Nineteen years. I entered college at sixteen and graduated at twenty. I will celebrate my twentieth year next fall.”")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("“You’re forty?”")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("“Not until December twenty-third.”")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("He whistled softly. “Damn,” he said softly. “You don’t look more than thirty-four, maybe five.”")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("She silently accepted his compliment. “How old are you?”")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("“Thirty-three.”")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("There was something about Tyrell that made him appear very worldly to Viola. He did not look old, yet his demeanor wasn’t that of a man in his early thirties.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("“Why did you decide to become a chef?”")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("Tyrell smiled at Viola. “I’ll tell you over dinner.”")]), _vm._v(" "), _c('p', {
    staticClass: "orn"
  }, [_vm._v("*   *   *")]), _vm._v(" "), _c('p', {
    staticClass: "sb"
  }, [_vm._v("Viola was totally charmed by her dining partner as they shared an appetizer of chilled shrimp with a fiery cocktail sauce, followed by sesame-crusted catfish with a peanut sauce, brown roux, and sautéed okra.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("She listened intently as he told of his fascination with cooking and the ingredients that made up any dish. After graduating high school he’d entered the Culinary Institute of America. Years later he returned to France, enrolling in graduate courses at the La Varenne École de Cuisine.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("“Every February I take a month off from Leo’s and travel either overseas or to other states to study with chefs featuring regional cuisine.”")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("Viola touched the corners of her mouth with a linen napkin. “You feel you’re ready to open a cooking school?”")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("Tyrell stared at her over the rim of his glass of sparkling water. “More than ready.”")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("“Do you have a site for your school?”")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("He nodded. “I closed on a building two months ago.”")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("“Where?” When he told her Viola gasped. “That’s two blocks from where I live.”")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("A wide smile curved his strong mouth. “You live in that new development with the loft apartments?”")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("“Yes.”")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("“Well hello, neighbor,” he said softly.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("Suddenly she felt the need to put some distance between her and Leo’s executive chef. Glancing at her watch, she noted the time. It was six-twenty. She had just spent more than two hours with Tyrell Hardcastle.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("Placing her napkin beside her plate, she attempted to stand, but Tyrell was beside her, pulling back the chair. “You’re leaving?”")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("“I’ve taken up enough of your time.”")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("He stared at her from under lowered lids. “Why don’t you let me be the judge of that?”")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("Tyrell was standing so close Viola could feel the whisper of his breath in her ear. “I have to leave, Tyrell. My workday begins at seven-twenty.”")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("He took a step backward. Her day began early, while his did not begin until late afternoon. There was so much he wanted to know about Viola, but hadn’t asked her. He would find out what he needed to know about her using an unorthodox method. It wasn’t on the up-and-up, yet it wasn’t illegal.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("She smiled. “I’ll talk to the students about rethinking a career in culinary arts.”")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("“I would appreciate that. I expect the school to begin operating next fall. The space has to be renovated and outfitted with all of the necessary equipment before I’m licensed by the Department of Education, and it has to pass inspection by the fire department.”")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("Viola nodded. “Thank you for dinner. Your cooking is incredible.”")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("Tyrell wanted to tell Viola "), _c('span', {
    staticClass: "epub-i"
  }, [_vm._v("she")]), _vm._v(" was incredible. He couldn’t remember the last time he had felt so relaxed, at ease with a woman.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("“Perhaps we can do it again, even if your students decide they don’t want to be chefs.”")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("“Of course. I’ll be certain to add Leo’s to my favorite restaurants.”")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("Successfully masking his disappointment, Tyrell smiled at her. “I’ll look forward to that.” He didn’t want her to become another face in the crowd at Leo’s. “How about next Monday?”")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("Viola wanted to reject the offer outright, but something wouldn’t let her. “I’ll call and let you know.”")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("He escorted her back to the kitchen to retrieve her handbag, then walked with her to the parking lot. There were only two vehicles in the lot—her Honda and a late-model Toyota SUV.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("Waiting until she was seated behind the wheel, Tyrell winked at her. “Get home safe.”")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("Smiling up into his sun-lit eyes, Viola flashed a sexy smile. “I will. And thank you for everything.”")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_c('span', {
    staticClass: "epub-i"
  }, [_vm._v("No, Viola. Thank you.")]), _vm._v(" He closed the door, stepped back, and watched as she drove away. He was still standing in the same spot long after her car turned the corner.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("Slipping his hands into the pockets of his slacks, he angled his head. Viola Chapman had cracked the shell he had put up around him to shield his heart ever since the woman he thought he’d love to his last breath deceived him.")]), _vm._v(" "), _c('p', {
    staticClass: "orn"
  }, [_vm._v("*   *   *")]), _vm._v(" "), _c('p', {
    staticClass: "sb"
  }, [_vm._v("The fact that Viola was an older woman never entered Tyrell’s mind until he lay in his king-size bed—alone—later that night. He smiled in the darkness, then turned over on his belly to ease the growing hardness between his thighs. Just thinking about Viola had sent his hormones into overdrive.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("It wasn’t that he was celibate, but whenever he took a woman to his bed it was not in passion as much as it was for a physical release. He had given one woman all of his love and his passion. He recalled the woman with a lying tongue, a woman who had promised to share her life with him, only to fulfill that promise with another man. That had been three years ago.")]), _vm._v(" "), _c('p', {
    staticClass: "orn"
  }, [_vm._v("*   *   *")]), _vm._v(" "), _c('p', {
    staticClass: "sb"
  }, [_vm._v("Viola stood in front of the full-length mirror on the bathroom door, surveying her nude body. "), _c('span', {
    staticClass: "epub-i"
  }, [_vm._v("No wonder you’re so skinny.")]), _vm._v(" She wasn’t as skinny as she was slender. Her hips were small, inherited from her paternal grandmother. However, her breasts and legs more than compensated. Her breasts weren’t large, yet they appeared fuller because of her narrow rib cage.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("“Forget you, Tyrell,” she whispered to her image. No man had ever complained about her body before; besides, at nearly forty she knew she looked good.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("Damn good.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("Slipping a pale pink silk gown over her head, she readied herself for bed.")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-ecf59e72","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/xhtml/chapter2.vue
// module id = 78
// module chunks = 0